import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './components/styles/theme';
import { GlobalStyle } from './components/styles/GlobalStyle';
import { AppContainer, MainContent } from './components/styles/AppStyles';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './components/About';
import Footer from './components/Footer';
import SocialSidebar from './components/SocialSidebar';
import International from './pages/International';
import CountryHub from './pages/CountryArticles';
import ExpensesCalculator from './pages/ExpensesCalculator';
import ArticleNavigationWrapper from './components/Article/ArticleNavigationWrapper';
import DestinationNavigationWrapper from './components/Article/DestinationNavigationWrapper';
import Terms from './pages/Terms';
import ContactForm from './components/Contact-Form';
import {
  GetYourGuideRedirect,
  KlookRedirect,
  TwelveGoRedirect,
  AiraloNewCustomersRedirect,
  AiraloExistingCustomersRedirect,
  TripRedirect,
} from './redirects';
import ReactGA from 'react-ga4';
import GAListener from './GAListener';
import ScrollToTop from './components/ScrollToTop';

function App() {
  useEffect(() => {
    ReactGA.initialize('G-EBYRY0359K');
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router basename="/">
        <AppContainer>
          <Navbar />
          <SocialSidebar />
          {/* <AccessibilitySettings /> */}
          <MainContent>
            <GAListener />
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/international" element={<International />} />
              <Route path="/international/:country" element={<CountryHub />} />
              <Route
                path="/international/:country/destination/:destination"
                element={<DestinationNavigationWrapper />}
              />
              <Route
                path="/international/:country/article/:slug"
                element={<ArticleNavigationWrapper />}
              />
              <Route path="/calculator" element={<ExpensesCalculator />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<ContactForm />} />
              <Route path="/klook" element={<KlookRedirect />} />
              <Route
                path="/get-your-guide"
                element={<GetYourGuideRedirect />}
              />
              <Route path="/12go" element={<TwelveGoRedirect />} />
              <Route
                path="/airalo-new-customers-15"
                element={<AiraloNewCustomersRedirect />}
              />
              <Route
                path="/airalo-existing-customers-10"
                element={<AiraloExistingCustomersRedirect />}
              />
              <Route path="/trip" element={<TripRedirect />} />
            </Routes>
          </MainContent>
          <Footer />
        </AppContainer>
      </Router>
    </ThemeProvider>
  );
}

export default App;
